import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { ChangeControlLifeCycle } from '../models/change-control-life-cycle';
import { AuditConstants } from '../../../../../shared/constants/audit-constants';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-change-control-life-cycle',
  templateUrl: './change-control-life-cycle.component.html',
  styleUrls: ['./change-control-life-cycle.component.scss'],
})
export class ChangeControlLifeCycleComponent implements OnInit, OnChanges {
  @Input() auditLifecycleInput: ChangeControlLifeCycle[] = [];
  IsDataLoaded: boolean = false;
  private phaseOrder = AuditConstants.changeControlPhaseOrder;
  constructor(
    private changeDetectorRef: ChangeDetectorRef
  ) {}
  ngOnInit(): void {
  }
  ngOnChanges(changes: SimpleChanges): void {
    const datePipe = new DatePipe('en-US');
    if (changes['auditLifecycleInput'] && this.auditLifecycleInput.length > 0) {
      this.auditLifecycleInput.forEach((entity, i) => {
        const currentPhaseIndex = this.phaseOrder.indexOf(entity.phaseName);
        const prevEntity = this.auditLifecycleInput[i - 1];
        const prevPhaseIndex = prevEntity
          ? this.phaseOrder.indexOf(prevEntity.phaseName)
          : -1;
        entity.arrowColor =
          currentPhaseIndex > prevPhaseIndex ? 'green-arrow' : 'red-arrow';
        entity.userDetails = entity.userDetails
          .map((user) => ({
            ...user,
            date: datePipe.transform(user.transactionDate, 'dd-MMM-yy'),
          }))
          .sort((a, b) => {
            if (!a.date || !b.date) {
              return 0;
            }
            return (
              a.date.localeCompare(b.date) ||
              a.userName.localeCompare(b.userName)
            );
          });
      });
    }
    this.changeDetectorRef.detectChanges();
  }
}
